import { Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";


export default function TagsFormControl(props={tags: [], setTags: undefined, tagChoices: []}) {
  const {tags, setTags, tagChoices} = props

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <FormControl fullWidth>
      <Select
        placeholder="Select tags"
        multiple
        value={tags}
        onChange={(e) => { if (setTags !== undefined) setTags(e.target.value)}}
        input={<OutlinedInput  />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((tag) => (
              <Chip key={tag} label={tag} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {tagChoices.map((tag) => (
          <MenuItem key={tag} value={tag}>
            {tag}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}